import { render, staticRenderFns } from "./SuperClienteFormComponent.vue?vue&type=template&id=752f57da&"
import script from "./SuperClienteFormComponent.vue?vue&type=script&lang=js&"
export * from "./SuperClienteFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports